import React, { Component } from 'react'
import ProductSelectionStep from 'components/SalesWizard/Steps/ProductSelectionStep';
import { fetchSaleOrder, updateProductSaleOrder, cleanSaleOrder } from "reducers/saleorder/saleorderActions";
import { connect } from 'react-redux';

import { withRouter } from 'react-router';


class SaleProductUpdate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orderStatus: null,
            saleOrderId: null
        }
    }

    componentDidMount() {
        const queryParams = this.props.router.history.location.search;
        const params = new URLSearchParams(queryParams.replace("?", ""));
        this.props.cleanSaleOrder();

        console.log("saleProductUpdate this.props", this.props);

        const saleOrderId = params.get('saleOrderId');
        if (saleOrderId != null && saleOrderId !== "") {
            this.setState({ saleOrderId: saleOrderId });
            this.props.fetchSaleOrder(saleOrderId);
        }

        const orderStatus = params.get('orderStatus');
        if (orderStatus != null && orderStatus !== "") {
            this.setState({ orderStatus: orderStatus });
        }

    }

    render() {
        return (
            <div>
                <ProductSelectionStep
                    saleOrderId={this.state.saleOrderId}
                    productEdit={true}
                    orderStatus={this.state.orderStatus}
                    postUpdateProduct={this.props.updateProductSaleOrder} />
            </div>
        )
    }
}

const mapStateToProps = state => ({
});

export default connect(
    mapStateToProps,
    { fetchSaleOrder, updateProductSaleOrder, cleanSaleOrder }
)(withRouter(SaleProductUpdate));



// WEBPACK FOOTER //
// ./src/components/SaleProductUpdate/SaleProductUpdate.jsx